export default __webpack_public_path__ + "static/media/chemistryLabImage.282c1563.png";